import type { ComponentThemeStyles } from './types';

export const gradientTheme: ComponentThemeStyles = {
  typography: {
    headingFont: 'Poppins, system-ui, sans-serif',
    bodyFont: 'Poppins, system-ui, sans-serif',
    baseSize: '16px',
  },
  navbar: {
    background: 'bg-gradient-to-r from-purple-600 via-pink-600 to-red-600',
    text: 'text-white',
    brandText: 'text-white',
    linkText: 'text-white',
    linkHover: 'hover:text-cyan-200',
    border: '',
    shadow: 'shadow-xl',
  },
  navigationMenu: {
    background: 'bg-gradient-to-r from-purple-600 via-pink-600 to-red-600',
    text: 'text-white',
    brandText: 'text-white',
    linkText: 'text-white',
    linkHover: 'hover:text-cyan-200',
    border: '',
    shadow: 'shadow-xl',
    dropdownBackground: 'bg-white',
    dropdownText: 'text-gray-800',
    dropdownHover: 'hover:bg-gray-50',
  },
  hero: {
    background: 'bg-gradient-to-br from-blue-600 via-purple-600 to-pink-600',
    text: 'text-white',
    buttonStyle: 'bg-white text-purple-600 hover:bg-gray-100',
    overlay: 'bg-black/10',
    pattern: true,
  },
  splitHero: {
    background: '#ffffff',
    text: '#111827',
    titleColor: '#000000',
    subtitleColor: '#6b7280',
    taglineColor: '#9333ea',
    buttonBg: '#9333ea',
    buttonText: '#ffffff',
    buttonHover: '#7e22ce',
  },
  htmlSplit: {
    background: '#ffffff',
    text: '#111827',
    titleColor: '#000000',
    subtitleColor: '#6b7280',
    taglineColor: '#9333ea',
    buttonBg: '#9333ea',
    buttonText: '#ffffff',
    buttonHover: '#7e22ce',
  },
  simpleHeader: {
    background: 'linear-gradient(to bottom right, #fce7f3, #faf5ff)',
    titleColor: '#581c87',
    subtitleColor: '#7e22ce',
  },
  features: {
    background: 'bg-gradient-to-br from-purple-50 via-pink-50 to-red-50',
    cardBg: 'bg-white/90 backdrop-blur',
    iconColor: 'text-purple-600',
    titleColor: 'text-gray-900',
    textColor: 'text-gray-600',
    borderRadius: 'rounded-xl',
  },
  footer: {
    background: 'bg-gradient-to-r from-gray-900 via-purple-900 to-gray-900',
    text: 'text-white',
    mutedText: 'text-purple-300',
    border: '',
  },
  cta: {
    background: 'bg-gradient-to-r from-orange-500 via-pink-500 to-purple-600',
    text: 'text-white',
    buttonStyle: 'bg-white text-purple-600 hover:bg-gray-100',
  },
  form: {
    background: 'bg-gradient-to-br from-white to-purple-50',
    inputBg: 'bg-white',
    inputBorder: 'border-purple-300',
    inputText: 'text-gray-900',
    labelColor: 'text-purple-700',
    buttonStyle: 'bg-gradient-to-r from-purple-600 to-pink-600 text-white hover:opacity-90',
  },
  pricing: {
    background: 'bg-gradient-to-br from-purple-50 via-pink-50 to-red-50',
    cardBg: 'bg-white/90 backdrop-blur',
    highlightedCard: 'bg-gradient-to-br from-purple-600 via-pink-600 to-red-600 text-white',
    titleColor: 'text-gray-900',
    subtitleColor: 'text-purple-700',
    descriptionColor: 'text-purple-600',
    planTitle: 'text-gray-900',
    planDescription: 'text-purple-600',
    priceColor: 'text-gray-900',
    periodColor: 'text-purple-600',
    featureColor: 'text-gray-700',
    checkColor: '#a855f7',
    highlightedTitle: 'text-white',
    highlightText: '#a855f7',
    highlightedDescription: 'text-purple-100',
    highlightedPrice: 'text-white',
    highlightedPeriod: 'text-purple-100',
    highlightedFeature: 'text-white',
    highlightedCheckColor: '#ffffff',
    borderColor: 'border-purple-200',
    highlightBorder: 'border-purple-400',
    highlightRing: 'ring-purple-500',
    hoverGlow: 'hover:shadow-purple-500/25',
    badgeBg: 'linear-gradient(to right, #a855f7, #ec4899)',
    badgeText: 'white',
    buttonBg: '#a855f7',
    highlightedButtonBg: '#ffffff',
  },
  mediaText: {
    background: 'linear-gradient(to right, #faf5ff, #fce7f3)',
    titleColor: '#581c87',
    textColor: '#6b21a8',
    accentColor: '#a855f7',
  },
  faq: {
    background: 'linear-gradient(to bottom right, #faf5ff, #fce7f3)',
    titleColor: '#581c87',
    subtitleColor: '#7e22ce',
    questionColor: '#581c87',
    answerColor: '#6b21a8',
    itemBackground: '#ffffff',
    itemBorder: '#e9d5ff',
    iconColor: '#a855f7',
  },
  testimonials: {
    background: 'linear-gradient(to bottom right, #fce7f3, #faf5ff)',
    titleColor: '#581c87',
    subtitleColor: '#7e22ce',
    cardBackground: '#ffffff',
    cardBorder: '#e9d5ff',
    quoteColor: '#6b21a8',
    nameColor: '#581c87',
    roleColor: '#7e22ce',
    starColor: '#a855f7',
  },
  countdownTimer: {
    background: 'linear-gradient(to bottom right, #fce7f3, #faf5ff)',
    text: '#581c87',
    headline: '#581c87',
    subheadline: '#7e22ce',
    number: '#a855f7',
    label: '#7e22ce',
  },
  imageGallery: {
    background: 'linear-gradient(to bottom right, #fce7f3, #faf5ff)',
    text: '#581c87',
    title: '#581c87',
    subtitle: '#7e22ce',
    caption: '#6b21a8',
    filterButton: '#f3e8ff',
    filterButtonActive: '#a855f7',
  },
  imageInfo: {
    background: 'linear-gradient(to bottom right, #fce7f3, #faf5ff)',
    text: '#581c87',
    title: '#581c87',
    subtitle: '#7e22ce',
    imageBorder: '#f3e8ff',
    buttonBg: '#a855f7',
    buttonText: '#ffffff',
  },
  imageCard: {
    background: 'linear-gradient(to bottom right, #fce7f3, #faf5ff)',
    overlayColor: '#581c87',
    title: '#ffffff',
    description: '#f3e8ff',
    buttonBg: '#a855f7',
    buttonText: '#ffffff',
  },
  team: {
    background: 'linear-gradient(to bottom right, #fce7f3, #faf5ff)',
    cardBg: '#ffffff',
    nameColor: '#581c87',
    roleColor: '#7e22ce',
    borderColor: '#e9d5ff',
  },
  video: {
    background: 'linear-gradient(to bottom right, #fce7f3, #faf5ff)',
    titleColor: '#581c87',
    subtitleColor: '#7e22ce',
    textColor: '#6b21a8',
  },
  textBlocks: {
    background: '#ffffff',
    titleColor: '#581c87',
    textColor: '#6b21a8',
    linkColor: '#a855f7',
  },
  titleSubtitle: {
    background: 'linear-gradient(to bottom right, #fce7f3, #faf5ff)',
    titleColor: '#581c87',
    subtitleColor: '#7e22ce',
    buttonBg: '#a855f7',
    buttonText: '#ffffff',
  },
  contactInfo: {
    background: 'linear-gradient(to bottom right, #fce7f3, #faf5ff)',
    titleColor: '#581c87',
    textColor: '#6b21a8',
    accentColor: '#a855f7',
  },
  headContent: {},
  bodyEnd: {},
  htmlEmbed: {
    background: '#ffffff',
  },
  promoBanner: {
    background: 'linear-gradient(to right, #ec4899, #8b5cf6)',
    text: '#ffffff',
    linkText: '#ffffff',
    dismissButton: '#ffffff',
  },
  logocloud: {
    background: '#faf5ff',
    titleColor: '#7c3aed',
    subtitleColor: '#6b7280',
  },
  stats: {
    background: '#f5f3ff',
    titleColor: '#5b21b6',
    subtitleColor: '#6b7280',
    valueColor: '#7c3aed',
    labelColor: '#374151',
    descriptionColor: '#6b7280',
  },
  blogPreview: {
    background: '#faf5ff',
    titleColor: '#5b21b6',
    subtitleColor: '#6b7280',
    cardBackground: '#ffffff',
    cardTitle: '#1e293b',
    cardExcerpt: '#4b5563',
    linkColor: '#7c3aed',
  },
  conversionPopup: {
    overlay: 'rgba(0,0,0,0.55)',
    panelBackground: '#ffffff',
    headlineColor: '#581c87',
    bodyTextColor: '#4b5563',
    buttonBackground: '#7c3aed',
    buttonText: '#ffffff',
    closeButton: '#6b7280',
  },
  blog: {
    pageBackground: 'linear-gradient(to bottom right, #faf5ff, #fce7f3)',
    headerBackground: '#ffffff',
    titleColor: '#581c87',
    descriptionColor: '#7e22ce',
    textColor: '#6b21a8',
    mutedTextColor: '#a855f7',
    linkColor: '#a855f7',
    linkHoverColor: '#9333ea',
    cardBackground: '#ffffff',
    cardBorder: '#e9d5ff',
    cardShadow: '0 4px 6px rgba(168, 85, 247, 0.1)',
    cardHoverShadow: '0 10px 15px rgba(168, 85, 247, 0.2)',
    postTitleColor: '#581c87',
    postTextColor: '#6b21a8',
    postMetaColor: '#7e22ce',
    tagBackground: '#f5f3ff',
    tagText: '#6b21a8',
    tagActiveBackground: 'linear-gradient(to right, #a855f7, #ec4899)',
    tagActiveText: '#ffffff',
    sidebarBackground: '#ffffff',
    sidebarTitleColor: '#581c87',
    paginationBackground: '#ffffff',
    paginationText: '#6b21a8',
    paginationBorder: '#e9d5ff',
    paginationActiveBackground: '#a855f7',
    paginationActiveText: '#ffffff',
    paginationDisabledOpacity: '0.5',
    iconColor: '#7e22ce',
    loadingSpinnerColor: '#a855f7',
    errorIconColor: '#d8b4fe',
    errorButtonBackground: '#a855f7',
    errorButtonText: '#ffffff',
  },
};
